import { FIRESTORE_PREDEFINED_FIELDS } from './firestore.constants';
import { FirestorePredefinedFields } from './firestore.models';

export function omitFirestoreFields<T>(data: T): T {
  if (!data) return data;

  const result = { ...data } as FirestorePredefinedFields;
  delete result[FIRESTORE_PREDEFINED_FIELDS.ID];
  return result as T;
}
